import React, { useEffect, useState } from 'react'
import { validateFunctionalForm } from '../../../../utils'
import Select from 'react-select';
import { v3_lead_owners } from '../../../../actions/v3/candidates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

const Add = (props) => {
    const [imageUrl, setImageUrl] = useState(null);
    const [state, setState] = useState({
        CLIENT_NAME: { name: 'CLIENT_NAME', value: '', error: '', isRequired: true },
        COMPANY_NAME: { name: 'COMPANY_NAME', value: '', error: '', isRequired: true },
        PHONE: { name: 'PHONE', value: '', error: '', isRequired: true },
        EMAIL: { name: 'EMAIL', value: '', error: '', isRequired: true },
        CLIENT_ADDRESS: { name: 'CLIENT_ADDRESS', value: '', error: '', isRequired: true },
        CLIENT_DETAILS: { name: 'CLIENT_DETAILS', value: '', error: '', isRequired: false },
        AGREEMENT_START_DATE: { name: 'AGREEMENT_START_DATE', value: '', error: '', isRequired: true },
        AGREEMENT_END_DATE: { name: 'AGREEMENT_END_DATE', value: '', error: '', isRequired: true },
        CLIENT_DOC: { name: 'CLIENT_DOC', value: '', error: '', isRequired: false },
        SERVICE_AGREEMENT_DOC: { name: 'SERVICE_AGREEMENT_DOC', value: '', error: '', isRequired: false },
        RATE_CARD: { name: 'RATE_CARD', value: '', error: '', isRequired: false },
        GST_NO: { name: 'GST_NO', value: '', error: '', isRequired: false },
        LOGO: { name: 'LOGO', value: '', error: '', isRequired: false },
        INTERNAL_SPOC: { name: 'INTERNAL_SPOC', value: '',options:[], error: '', isRequired: true },

    })
    const clearForm = () => {
        setState({
            CLIENT_NAME: { name: 'CLIENT_NAME', value: '', error: '', isRequired: true },
            COMPANY_NAME: { name: 'COMPANY_NAME', value: '', error: '', isRequired: true },
            PHONE: { name: 'PHONE', value: '', error: '', isRequired: true },
            EMAIL: { name: 'EMAIL', value: '', error: '', isRequired: true },
            CLIENT_ADDRESS: { name: 'CLIENT_ADDRESS', value: '', error: '', isRequired: true },
            CLIENT_DETAILS: { name: 'CLIENT_DETAILS', value: '', error: '', isRequired: false },
            AGREEMENT_START_DATE: { name: 'AGREEMENT_START_DATE', value: '', error: '', isRequired: true },
            AGREEMENT_END_DATE: { name: 'AGREEMENT_END_DATE', value: '', error: '', isRequired: true },
            CLIENT_DOC: { name: 'CLIENT_DOC', value: '', error: '', isRequired: false },
            SERVICE_AGREEMENT_DOC: { name: 'SERVICE_AGREEMENT_DOC', value: '', error: '', isRequired: false },
            RATE_CARD: { name: 'RATE_CARD', value: '', error: '', isRequired: false },
            GST_NO: { name: 'GST_NO', value: '', error: '', isRequired: false },
            LOGO: { name: 'LOGO', value: '', error: '', isRequired: false },
            INTERNAL_SPOC: { name: 'INTERNAL_SPOC', value: '',options:[], error: '', isRequired: true },

        });
        setImageUrl(null)
    }
    const setOptions = (name, options) => {
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: options
            }
        }));
    }
    useEffect(()=>{
        v3_lead_owners().then((res)=>{
          setOptions('INTERNAL_SPOC',res.result.map((item) => {
            return {
                value: item.USER_ID,
                label: item.FULL_NAME
            }
        }))  
        })
    },[])

    const onChange = (e) => {
        const { name, value } = e.target;
        if (name === state.PHONE.name) {
            const numericPhoneNumber = value.replace(/\D/g, '');
            setState(prevState => ({
                ...prevState,
                [name]: {
                    ...prevState[name],
                    value: numericPhoneNumber
                }
            }));
        }
        else {
            setState(prevState => ({
                ...prevState,
                [name]: {
                    ...prevState[name],
                    value: value
                }
            }));
        }

    };

    const onSubmit = () => {
        if (validateFunctionalForm(state, setState)) {
            const model = {
                CLIENT_NAME: state.CLIENT_NAME.value,
                EMAIL: state.EMAIL.value,
                PHONE: state.PHONE.value,
                COMPANY_NAME: state.COMPANY_NAME.value,
                CLIENT_ADDRESS: state.CLIENT_ADDRESS.value,
                CLIENT_DETAILS: state.CLIENT_DETAILS.value,
                AGREEMENT_START_DATE: state.AGREEMENT_START_DATE.value,
                AGREEMENT_END_DATE: state.AGREEMENT_END_DATE.value,
                CLIENT_DOC: state.CLIENT_DOC.value,
                SERVICE_AGREEMENT_DOC: state.SERVICE_AGREEMENT_DOC.value,
                RATE_CARD: state.RATE_CARD.value,
                GST_NO: state.GST_NO.value,
                LOGO: state.LOGO.value,
                INTERNAL_SPOC: state.INTERNAL_SPOC.value.map(item=>{return item.value}),
            }
            const formData = new FormData();
            for (const key in model) {
                if (model.hasOwnProperty(key)) {
                    formData.append(key, model[key]);
                }
            }
            props.onSubmit(formData)
        }
    }
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setState(prevState => ({
                ...prevState,
                ['LOGO']: {
                    ...prevState['LOGO'],
                    value: file
                }
            }));
            const reader = new FileReader();
            reader.onloadend = () => {
                // Update the state with the data URL
                setImageUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <React.Fragment>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row my-2">
                            <div className="col-12">
                                <div className="page-title-box d-flex justify-content-between">
                                    <h4 className="mb-sm-0">Add Client</h4>
                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item">
                                                <a href="javascript: void(0);">Client Management</a>
                                            </li>
                                            <li className="breadcrumb-item active">Add Client</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card ct-card rounded-10">
                                    <div className="p-3 pb-0 align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Client</h4>
                                    </div>
                                    <hr/>
                                    <div className="card-body">
                                        <div className="live-preview">
                                            <div className="row gy-4">
                                                <div className="col-xxl-3 col-md-6">
                                                    <div className="flex-shink-0 upload-btn">
                                                        <img
                                                            src={imageUrl ? imageUrl : "/assets/images/companies/default-logo.png"}
                                                            alt=""
                                                            className="img-fluid upload-imgop rounded"
                                                        />
                                                        <div>
                                                        <label htmlFor="profile_pic" className="mb-0 edit-btnop" ><FontAwesomeIcon icon={faUpload} className='pe-2'/>Click here to Upload</label>
                                                        <input
                                                            type="file"
                                                            id="profile_pic"
                                                            accept="image/*"
                                                            onChange={handleFileChange}
                                                            style={{ display: "none" }}
                                                        />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Company Name
                                                            <span className='text-danger'>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={!state.COMPANY_NAME.value && state.COMPANY_NAME.error ? "form-control is-invalid" : "form-control"}
                                                            placeholder='Company Name'
                                                            name={state.COMPANY_NAME.name}
                                                            value={state.COMPANY_NAME.value}
                                                            onChange={onChange}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div >
                                                        <label className="form-label ctlabel">
                                                            Email
                                                            <span className='text-danger'>*</span>

                                                        </label>
                                                        <div className='form-icon'>
                                                            <input
                                                                type="email"
                                                                placeholder="Email"
                                                                className={!state.EMAIL.value && state.EMAIL.error ? "form-control form-control-icon is-invalid" : "form-control form-control-icon"}
                                                                name={state.EMAIL.name}
                                                                value={state.EMAIL.value}
                                                                onChange={onChange}
                                                            />
                                                            <i className='ri-mail-unread-line' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            SPOC Name
                                                            <span className='text-danger'>*</span>

                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={!state.CLIENT_NAME.value && state.CLIENT_NAME.error ? "form-control is-invalid" : "form-control"}

                                                            placeholder='SPOC Name'
                                                            name={state.CLIENT_NAME.name}
                                                            value={state.CLIENT_NAME.value}
                                                            onChange={onChange}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Phone
                                                            <span className='text-danger'>*</span>

                                                        </label>
                                                        <div className='form-icon'>
                                                            <input
                                                                type="tel"  // Use type="tel" for phone numbers
                                                                maxLength="10"  // Maximum length for a typical phone number
                                                                className={!state.PHONE.value && state.PHONE.error ? "form-control form-control-icon is-invalid" : "form-control form-control-icon"}

                                                                placeholder="Phone"
                                                                name={state.PHONE.name}
                                                                value={state.PHONE.value}
                                                                onChange={onChange}
                                                            />
                                                            <i className='ri-phone-line' />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            GST No
                                                        </label>
                                                        <div className=''>
                                                            <input
                                                                type="text"
                                                                className={!state.GST_NO.value && state.GST_NO.error ? "form-control is-invalid" : "form-control"}

                                                                placeholder="GST No"
                                                                name={state.GST_NO.name}
                                                                value={state.GST_NO.value}
                                                                onChange={onChange}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Agreement Start Date
                                                            <span className='text-danger'>*</span>

                                                        </label>
                                                        <div className=''>
                                                            <input
                                                                type="date"
                                                                className={!state.AGREEMENT_START_DATE.value && state.AGREEMENT_START_DATE.error ? "form-control is-invalid" : "form-control"}

                                                                name={state.AGREEMENT_START_DATE.name}
                                                                value={state.AGREEMENT_START_DATE.value}
                                                                onChange={onChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Agreement End Date
                                                            <span className='text-danger'>*</span>

                                                        </label>
                                                        <div className=''>
                                                            <input
                                                                type="date"
                                                                className={!state.AGREEMENT_END_DATE.value && state.AGREEMENT_END_DATE.error ? "form-control is-invalid" : "form-control"}

                                                                name={state.AGREEMENT_END_DATE.name}
                                                                value={state.AGREEMENT_END_DATE.value}
                                                                onChange={onChange}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Client Document
                                                        </label>
                                                        <div className=''>
                                                            <input
                                                                type="file"
                                                                className={!state.CLIENT_DOC.value && state.CLIENT_DOC.error ? "form-control is-invalid" : "form-control"}

                                                                name={state.CLIENT_DOC.name}
                                                                onChange={(e) => {
                                                                    setState(prevState => ({
                                                                        ...prevState,
                                                                        ['CLIENT_DOC']: {
                                                                            ...prevState['CLIENT_DOC'],
                                                                            value: e.target.files[0]
                                                                        }
                                                                    }));
                                                                }}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Service Agreement Document
                                                        </label>
                                                        <div className='form-icon'>
                                                            <input
                                                                type="file"
                                                                className={!state.SERVICE_AGREEMENT_DOC.value && state.SERVICE_AGREEMENT_DOC.error ? "form-control is-invalid" : "form-control"}

                                                                name={state.SERVICE_AGREEMENT_DOC.name}
                                                                onChange={(e) => {
                                                                    setState(prevState => ({
                                                                        ...prevState,
                                                                        ['SERVICE_AGREEMENT_DOC']: {
                                                                            ...prevState['SERVICE_AGREEMENT_DOC'],
                                                                            value: e.target.files[0]
                                                                        }
                                                                    }));
                                                                }}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Rate Card
                                                        </label>
                                                        <div className=''>
                                                            <input
                                                                type="file"
                                                                className={!state.RATE_CARD.value && state.RATE_CARD.error ? "form-control is-invalid" : "form-control"}

                                                                name={state.RATE_CARD.name}
                                                                onChange={(e) => {
                                                                    setState(prevState => ({
                                                                        ...prevState,
                                                                        ['RATE_CARD']: {
                                                                            ...prevState['RATE_CARD'],
                                                                            value: e.target.files[0]
                                                                        }
                                                                    }));
                                                                }}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div>
                                                        <label className="form-label ctlabel">Internal SPOC
                                                            <span className='text-danger'>&nbsp;*</span>

                                                        </label>
                                                        <Select
                                                            isMulti
                                                            name="INTERNAL_SPOC"
                                                            options={state.INTERNAL_SPOC.options}
                                                            value={state.INTERNAL_SPOC.value}
                                                            onChange={(e) => {
                                                                setState(prevState => ({
                                                                    ...prevState,
                                                                    ['INTERNAL_SPOC']: {
                                                                        ...prevState['INTERNAL_SPOC'],
                                                                        value: e
                                                                    }
                                                                }));
                                                            }}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                        />
                                                        <div className="invalid-feedback">
                                                            Please select internal spoc
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className='textarea-ct'>
                                                        <label className="form-label ctlabel">
                                                            Client Address
                                                            <span className='text-danger'>*</span>

                                                        </label>
                                                        <textarea
                                                            className={!state.CLIENT_ADDRESS.value && state.CLIENT_ADDRESS.error ? "form-control is-invalid" : "form-control"}
                                                            rows={2}
                                                            placeholder="Client Address"
                                                            name={state.CLIENT_ADDRESS.name}
                                                            value={state.CLIENT_ADDRESS.value}
                                                            onChange={onChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xxl-12 col-md-12">
                                                    <div>
                                                        <label className="form-label ctlabel">
                                                            Client Detail
                                                        </label>
                                                        <textarea
                                                            className={!state.CLIENT_DETAILS.value && state.CLIENT_DETAILS.error ? "form-control is-invalid" : "form-control"}

                                                            placeholder="Client Detail"
                                                            name={state.CLIENT_DETAILS.name}
                                                            value={state.CLIENT_DETAILS.value}
                                                            onChange={onChange}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-xxl-12 col-md-12 d-flex justify-content-end">
                                                    <button type="button" onClick={() => { onSubmit() }} class="btn dwnbtn">Add New</button>
                                                    <button type="button" onClick={() => { clearForm() }} class="btn FiltterButton ms-2">Clear Form</button>

                                                </div>

                                            </div>
                                            {/*end row*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*end col*/}
                        </div>
                    </div>{" "}
                </div>

            </div>

        </React.Fragment>
    )
}

export default Add